import React, { Component } from 'react'
import { FormattedMessage, defineMessages } from 'react-intl'

import Downloads from '../Downloads/Downloads'

import {
  Title,
  Wrapper,
  ContentWrapper,
  MainTextWrapper,
  InfoSection,
  Info
} from './ThanksFooter.styles'
import { GradientWrapper } from '../../../../DashboardSettings.styles'

const messages = defineMessages({
  thanksTitle: {
    id: 'dashboard.referrals.thanksTitle',
    defaultMessage:
      'Thanks for helping to spread the word about Night Zookeeper!'
  },
  thanksText: {
    id: 'dashboard.referrals.thanksText',
    defaultMessage:
      'Our aim is to encourage as many children around the world to fall in love with writing. Every time you share, more children have the opportunity to fall in love with writing.'
  }
})

const ThanksFooter = () => {
  return (
    <GradientWrapper direction='darkLeft'>
      <ContentWrapper>
        <MainTextWrapper>
          <Title type='main'>
            <FormattedMessage {...messages.thanksTitle} />
          </Title>
          <Info>
            <FormattedMessage {...messages.thanksText} />
          </Info>
        </MainTextWrapper>
        <InfoSection>
          <Downloads halfWidth noBg />
        </InfoSection>
      </ContentWrapper>
    </GradientWrapper>
  )
}

export default ThanksFooter
